export default __webpack_public_path__ + "static/media/python.15d0fce8.png";